import styled, { css } from 'styled-components'

// $nowrap — одна строка с горизонтальной прокруткой на мобильном (новая
// главная, business_apps#1486 §3); без пропа — перенос как раньше.
const FiltersWrapper = styled.div`
  && {
    display: flex;

    margin-top: 1rem;
    background: ${(p) => p.theme.palette.background.primary};
    overflow-x: auto;
    flex-wrap: wrap;
    & > * {
      margin-right: 1rem;
      margin-bottom: 0.625rem;
    }
    &::-webkit-scrollbar {
      height: 1px;
      background-color: transparent;
    }
    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgb(192, 192, 192);
    }
    ${(p) =>
      p.$nowrap &&
      css`
        @media screen and (max-width: ${(p) => p.theme.sizes.tablet}) {
          flex-wrap: nowrap;
          & > * {
            flex-shrink: 0;
          }
        }
      `}
  }
`

export default FiltersWrapper
